import { useRef } from 'react'

/**
 * Executes only on first mount before render
 * @param {function} cb - callback
 */
export const useComponentWillMount = (cb) => {
  const willMount = useRef(true)
  if (willMount.current) {
    cb()
  }
  willMount.current = false
}

/**
 * Adds bet and sidebets
 * @returns {number} Total bets
 */
export const getBet = (sideGames, betAmount) => {
  let value = betAmount
  for (let i = 0; i < sideGames.length; i++) {
    const _betAmount = sideGames[i].betAmount
    if (_betAmount) {
      value += _betAmount
    }
  }
  return value
}

/**
 * Prevents events from bubbling up and it's default behavior
 * @param {Event} event - callback
 */
 export const stopPropagation = event => {
  event.preventDefault()
  event.stopPropagation()
  return false
}